import React from "react";

const TermsAndConditions = () => {
  return (
        <div className="xl:px-[calc((100%-1250px)/2)] px-3 mt-60 mb-20">
      <h1 className="text-3xl font-bold text-[#2A668D] mb-4">Terms & Conditions</h1>
      <p className="mb-4">
        Welcome to Wehelpufirst. By accessing our website and using our services,
        you agree to be bound by the following terms and conditions:
      </p>

      <ol className="list-decimal ml-6 space-y-2">
        <li>
          <strong>Eligibility:</strong> You must be at least 18 years old to use our services.
        </li>
        <li>
          <strong>Account Responsibility:</strong> You are responsible for maintaining the
          confidentiality of your account information.
        </li>
        <li>
          <strong>Service Availability:</strong> We do not guarantee uninterrupted access
          to the platform and services.
        </li>
        <li>
          <strong>Content Ownership:</strong> All content on our platform is protected by
          copyright and trademark laws.
        </li>
        <li>
          <strong>Prohibited Activities:</strong> Users are not permitted to misuse the
          platform for illegal or unethical purposes.
        </li>
      </ol>

      <p className="mt-6">
        By continuing to use our services, you agree to abide by these terms. If you
        do not agree, please discontinue use immediately.
      </p>
    </div>
  );
};

export default TermsAndConditions;